import { connect } from 'react-redux';
import MarketoActivationView from './MarketoActivationView.jsx';
import { activateAccount } from 'src/legacy/redux/actions/integrations/marketo.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  return {
    activating: state.legacyRootReducer.settings.integrations.marketo.activation.activating,
    error: state.legacyRootReducer.settings.integrations.marketo.activation.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount : (configuration) => {
        return dispatch(activateAccount(configuration))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const MarketoActivationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(MarketoActivationView);

export default MarketoActivationPage;
